import { PollProdStackService } from 'types/services';
import { asyncTimeout, AsyncTimeoutAbortError } from 'utils/asyncTimeout';
import { m8API } from '../m8';
import { M8ProdStackDTO } from '../types';
import { normalizeM8ProdStackDTO } from '../utils/normalizeM8ProdStackDTO';
import { HTTPConnectionError, ProdStackPollingAbortError } from 'utils/errors';

export const pollProdStack: PollProdStackService = async (signal) => {
  let m8ProdStack: null | M8ProdStackDTO = null;

  while (m8ProdStack === null) {
    // Check for cancellation before each API call
    if (signal?.aborted) {
      throw new ProdStackPollingAbortError();
    }

    m8ProdStack = await m8API.user.getProdStackInfo().catch((error) => {
      if (error instanceof HTTPConnectionError) {
        // На iOS может возникать обрыв соединения
        // при сворачивании приложения с открытой страницей.
        return null;
      }

      throw error;
    });

    // Check for cancellation before timeout
    if (signal?.aborted) {
      throw new ProdStackPollingAbortError();
    }

    await asyncTimeout(5000, signal).catch((error) => {
      if (error instanceof AsyncTimeoutAbortError) {
        throw new ProdStackPollingAbortError();
      }

      throw error;
    });
  }

  const prodStackInfo = normalizeM8ProdStackDTO(m8ProdStack).toProdStackInfo();

  return prodStackInfo;
};
